// ─── WaterArt Header JS ───────────────────────────────────────
(function () {
  function initWaHeader() {
    var header    = document.querySelector('.wa-header');
    var burger    = document.querySelector('.wa-header__burger');
    var overlay   = document.querySelector('.wa-nav-overlay');
    var returnBtn = document.querySelector('.wa-nav__return');
    var closeBtn  = document.querySelector('.wa-nav__close');

    if (!header || !burger || !overlay) return;

    // ── Which page are we on, and is it in the "transparent" list? ──
    // These two data attributes are rendered by the section's liquid file
    // based on the "Transparent header on these pages" setting.
    var currentPageId   = header.getAttribute('data-page-id') || '';
    var transparentList = (header.getAttribute('data-transparent-pages') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    var isTransparentPage = transparentList.indexOf(currentPageId) !== -1;

    // ── Non-transparent pages: always solid ────────────────────
    if (!isTransparentPage) {
      header.classList.add('is-scrolled');
    }

    // ── Scroll logic (transparent pages only) ──────────────────
    function onScroll() {
      if (!isTransparentPage) return; // other pages: never remove solid bg
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ── Menu open / close ─────────────────────────────────────
    function openMenu() {
      burger.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      header.classList.add('is-scrolled');
    }

    function closeMenu() {
      burger.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      onScroll(); // re-check (only matters on transparent pages)
    }

    burger.addEventListener('click', function () {
      if (overlay.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (returnBtn) returnBtn.addEventListener('click', closeMenu);
    if (closeBtn)  closeBtn.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWaHeader);
  } else {
    initWaHeader();
  }

  document.addEventListener('shopify:section:load', initWaHeader);
})();